
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Sacroiliac_joint_disorder',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Sacroiliac_joint_disorder.vue